import type { SpacingObject, SpacingToken } from '../components/types';

export const isSpacingObject = (
  spacing: SpacingToken | SpacingObject | undefined,
): spacing is SpacingObject => {
  return (
    typeof spacing === 'object' && spacing?.desktop !== undefined && spacing?.mobile !== undefined
  );
};
